/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { connect } from 'react-redux';
import { routerActions } from 'react-router-redux';
import { injectIntl } from 'react-intl';
import SideBar from 'loracoms/SideBar';
import SidebarContainer from 'loracoms/SidebarContainer';
import appActions from 'loraactions/app';
import IntlMsg from 'lorautils/intl/IntlMsg';
import config from 'loracfg';
import styles from './styles.scss';

const defaultProps = {
  view: 'detail',
};

const propTypes = {
  intl: React.PropTypes.any.isRequired,
  appId: React.PropTypes.string.isRequired,
  getApp: React.PropTypes.func.isRequired,
  view: React.PropTypes.string,
  children: React.PropTypes.node.isRequired,
  pushState: React.PropTypes.func.isRequired,
  plan: React.PropTypes.object.isRequired,
};

class ApplicationDetail extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      view: props.view,
      showToken: false,
      plan: props.plan,
    };
    this.intlMsg = new IntlMsg(props.intl, 'applicationdetail');
  }

  componentWillMount() {
    const { appId, getApp } = this.props;
    getApp(appId);
  }

  componentWillReceiveProps(nextProps) {
    const { view, plan } = nextProps;
    if (view !== this.props.view) {
      this.setState({ view });
    }
    if (plan !== this.props.plan) {
      this.setState({ plan });
    }
  }

  renderSideBar() {
    const { pushState, appId } = this.props;
    const { view = 'detail' } = this.state;
    return (
      <SideBar
        height={window.innerHeight}
        title={this.intlMsg.msg('sidebar.title')}
        menuItems={[{
          icon: <span className="glyphicons glyphicons-blackboard" />,
          text: this.intlMsg.msg('menu.detail'),
          onClick: () => pushState(`/application/${appId}/detail`),
          active: view === 'detail' || view === '',
        }, {
          icon: <span className="glyphicons glyphicons-electrical-plug" />,
          text: this.intlMsg.msg('menu.api'),
          onClick: () => pushState(`/application/${appId}/api`),
          active: view === 'api',
        }, {
          icon: <span className="glyphicons glyphicons-notes-2" />,
          text: this.intlMsg.msg('menu.log'),
          onClick: () => pushState(`/application/${appId}/log`),
          active: view === 'log',
        }, {
          icon: <span className="glyphicons glyphicons-cloud-download" />,
          text: this.intlMsg.msg('menu.export'),
          onClick: () => pushState(`/application/${appId}/export`),
          active: view === 'export',
        }, {
          icon: <span className="glyphicons glyphicons-sort" />,
          text: this.intlMsg.msg('menu.parse'),
          onClick: () => pushState(`/application/${appId}/parse`),
          active: view === 'parse',
          // show: config.profile === 'cloud',
        }, {
          icon: <span className="glyphicons glyphicons-show-thumbnails" />,
          text: this.intlMsg.msg('menu.dps'),
          onClick: () => pushState(`/application/${appId}/dps`),
          active: view === 'dps',
          show: config.profile === 'cloud',
        }, {
          icon: <span className="glyphicons glyphicons-electricity" />,
          text: this.intlMsg.msg('menu.flows'),
          onClick: () => pushState(`/application/${appId}/flows`),
          active: view === 'flows',
          show: config.profile === 'cloud',
        }, {
          icon: <span className="glyphicons glyphicons-volume-up" />,
          text: this.intlMsg.msg('menu.broadcast'),
          onClick: () => pushState(`/application/${appId}/broadcast`),
          active: view === 'broadcast',
        }, {
          icon: <span className="glyphicons glyphicons-dashboard" />,
          text: this.intlMsg.msg('menu.dashboard'),
          onClick: () => pushState(`/application/${appId}/dashboard`),
          active: view === 'dashboard',
        }]}
      />
    );
  }

  render() {
    return (
      <div>
        {this.renderSideBar()}
        <SidebarContainer>
          <div className={styles.view}>
            {this.props.children}
          </div>
        </SidebarContainer>
      </div>
    );
  }
}

ApplicationDetail.defaultProps = defaultProps;
ApplicationDetail.propTypes = propTypes;


const mapStateToProps = (state, ownProps) => ({
  appId: ownProps.params.id,
  view: ownProps.location.pathname.split('/')[3] || '',
  plan: state.billing.plan,
});

const mapDispatchToProps = {
  getApp: appActions.getApp,
  pushState: routerActions.push,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(ApplicationDetail));




// WEBPACK FOOTER //
// ./src/containers/Application/coms/ApplicationDetail/index.jsx